/**
 * Processes input value for numeric fields
 * Removes leading zeros, non-numeric characters, and replaces commas with periods
 */
export const replaceInputValue = (val: string | null | undefined): string => {
  if (val === null || val === undefined) {
    return "";
  }

  return val
    .replace(/^0(\d)/, "$1")
    .replace(/[^0-9|.,]/g, "")
    .replace(/,/g, ".");
};
